module.exports = __webpack_public_path__ + "static/img/redshow_10@2x.bb60cef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/party/redshow_10@2x.png
// module id = nlUi
// module chunks = 0